<div class="container" [innerHTML]="htmlContent"></div>
